import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon'; // import Dropdown from '../Dropdown';

import { Row } from '../Grid';
import { useUrlParams } from '../hooks';
import { paginationContainer, shownResultsIndicator, paginationButton // pageSizeDropdown,
} from './styles'; // const defaultPageSizes = [10, 20, 50];
// const Pagination = forwardRef(({ tableOptions, getData, pageSizes }, ref) => {

import { jsx as ___EmotionJSX } from "@emotion/react";
var Pagination = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _urlQueryParams$pageI;

  var tableOptions = _ref.tableOptions,
      getData = _ref.getData;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var _useState = useState((_urlQueryParams$pageI = urlQueryParams === null || urlQueryParams === void 0 ? void 0 : urlQueryParams.pageIndex) !== null && _urlQueryParams$pageI !== void 0 ? _urlQueryParams$pageI : 0),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var _tableOptions$current = tableOptions.current,
      totalPages = _tableOptions$current.totalPages,
      pageProp = _tableOptions$current.pageIndex,
      pageSize = _tableOptions$current.pageSize,
      totalResults = _tableOptions$current.totalResults;
  var noResults = totalPages === 0;
  var needEllipses = totalPages > 5;
  useImperativeHandle(ref, function () {
    return {
      page: page,
      setPage: setPage
    };
  });
  useEffect(function () {
    setPage(pageProp);
  }, [pageProp]);

  var handlePageChange = function handlePageChange(newPage) {
    setPage(newPage);
    getData({
      pageIndex: newPage
    });
  };

  var arrowsButton = function arrowsButton(disabled, type) {
    return ___EmotionJSX("div", _extends({
      role: "button",
      tabIndex: 0,
      css: paginationButton(disabled, false)
    }, !disabled && {
      onClick: function onClick() {
        return handlePageChange(page - (type === 'left' ? 1 : -1));
      }
    }), ___EmotionJSX(Icon, {
      bold: true,
      size: 12,
      iconName: type === 'left' ? 'la la-angle-left' : 'la la-angle-right'
    }));
  };

  var pageButton = function pageButton(ind) {
    return ___EmotionJSX("span", _extends({
      key: ind,
      css: paginationButton(totalPages === 1, ind === page)
    }, totalPages !== 1 && page !== ind && {
      onClick: function onClick() {
        return handlePageChange(ind);
      }
    }), ind + 1);
  };

  var ellipsesElement = ___EmotionJSX("span", {
    css: paginationButton(true, false, true)
  }, "...");

  var fromIndex = page * pageSize + 1;
  var toIndex = (page + 1) * pageSize;
  return (// <Row justify="space-between">
    //   <Dropdown
    //     noClear
    //     onTop
    //     disabled={totalResults < 1}
    //     options={pageSizes ?? defaultPageSizes}
    //     value={urlQueryParams?.pageSize ?? tableOptions.current.pageSize}
    //     onChange={value => getData({ pageSize: value })}
    //     css={pageSizeDropdown}
    //   />
    ___EmotionJSX(Row, {
      justify: "flex-end",
      padding: "1.15em 0"
    }, ___EmotionJSX("div", {
      css: paginationContainer
    }, ___EmotionJSX("div", {
      css: shownResultsIndicator
    }, "".concat(fromIndex, " - ").concat(toIndex > totalResults ? totalResults : toIndex, " "), "(", totalResults !== null && totalResults !== void 0 ? totalResults : tableOptions.current.pageSize, ")"), arrowsButton(page === 0 || noResults, 'left'), needEllipses ? ___EmotionJSX(React.Fragment, null, pageButton(0), page > 2 && ellipsesElement, page > 1 && totalPages > 3 && pageButton(page - 1), page !== 0 && page !== totalPages - 1 && pageButton(page), page < totalPages - 2 && totalPages > 4 && pageButton(page + 1), totalPages - page > 3 && ellipsesElement, totalPages !== 1 && pageButton(totalPages - 1)) : Array(totalPages).fill().map(function (el, ind) {
      return pageButton(ind);
    }), arrowsButton(page === totalPages - 1 || noResults, 'right')))
  );
});
Pagination.propTypes = {
  tableOptions: PropTypes.object,
  getData: PropTypes.func // pageSizes: PropTypes.array,

};
export default Pagination;